module.exports = __webpack_public_path__ + "static/media/footer.6c1f57d0.jpg";